import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../utils/response';
import { Token, UserCode, Company, Worksite, EmployeeCode, EmployeeId } from '../../utils/users';
import { errorResponse } from '../../utils/response';
import { GetLanguage } from '../../utils/language';
import sortArray from 'sort-array';

export function addExpenseAccount(expenseId, expenseDate, expenseType, description, quantity, unitPay, rate, paymentType, project, activity, projectP, activityP, department, province, worksite, serviceProviderId, workPlaceId, taskCode, tipAmount) {
    
    return fetch('expenseAccount/save', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            expenseAccountPunchId: expenseId,
            company: Company(),
            language: GetLanguage(),
            employeeCode: EmployeeCode(),
            expenseDate: expenseDate,
            expenseAccountCode: expenseType,
            expenseAccountAmount: 0,
            description: description,
            quantity: Number(quantity),
            payUnit: unitPay,
            rate: Number(rate),
            employeeCreditCardId: paymentType,
            abcProjectCode: project !== '' ? project : null,
            activityCode: activity !== '' ? parseInt(activity) : null,
            projectCode: projectP !== '' ? projectP : null,
            activityPay: activityP !== '' ? activityP : null,
            departmentCode: department,
            worksite: worksite,
            provinceCode: province,
            loadPerformed: 'N',
            exchangeRate: 1,
            expenseAccountServiceProviderId: serviceProviderId,
            workPlaceId,
            taskCode,
            tipAmount,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let result = response.result;

                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function deleteExpenseAccount(expenseId) {
    return fetch('expenseAccount/delete', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            expenseAccountPunchId: expenseId,
            employeeId: EmployeeId(),
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let result = response.result;

                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function addDocument(listDocument) {
    let params = [];
    const company = Company();
    const language = GetLanguage();
    const employeeCode = EmployeeCode();
    const employeeId = EmployeeId();

    listDocument.forEach(item => {
        const obj = {
            expenseAccountId: item.expenseAccountId,
            fileName: item.fileName,
            descriptionFile: item.descriptionFile,
            documentBase64: item.documentBase64,
            documentType: item.documentType,
            company: company,
            language: language,
            employeeCode: employeeCode,
            employeeId: employeeId
        }

        params.push(obj);
    });

    return fetch('expenseAccount/saveDocument', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            documents: params,
            token: {
                userCode: UserCode(),
                token: Token()
            }
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let result = response.result;

                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function deleteDocument(documentId) {
    return fetch('expenseAccount/deleteDocument', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            documentId: documentId,
            userCode: UserCode(),
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let result = response.result;

                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function historyExpenseAccount(startDate, endDate, loadCharged) {
    let url = 'expenseAccount/getExpenseAccount?' + objectToQueryString(
        {
            loadCharged: loadCharged,
            userId: EmployeeId(),
            startDate: startDate,
            endDate: endDate,
            company: Company(),
            refundable: '%',
            expenseId: 0,
            userCode: UserCode(),
            token: Token()
        });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let expenseAccount = response.expenseAccount;

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getExpenseAccount(expenseId) {
    let url = 'expenseAccount/getExpenseAccountById?' + objectToQueryString({ expenseId: expenseId, userCode: UserCode(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let expenseAccount = response.expenseAccount;

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getExpenseAccountDocument(expenseId) {
    let url = 'expenseAccount/getDocument?' + objectToQueryString({ company: Company(), expenseAccountPunchId: expenseId, userCode: UserCode(), employeeId: EmployeeId(), language: GetLanguage(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let document = response.document;

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortByDateAndId(data) {
    const list = sortArray(data, {
        by: ['expenseDate', 'expenseAccountPunchId'],
        order: ['desc', 'desc']
    });

    return list;
}

export function loadCombos(date, jobTitle, department) {
    let url = 'expenseAccount/combos?' + objectToQueryString(
        {
            company: Company(),
            worksite: Worksite(),
            userCode: UserCode(),
            employeeCode: EmployeeCode(),
            employeeId: EmployeeId(),
            date: date,
            jobTitle: jobTitle,
            department: department,
            token: Token()
        });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}